import React from 'react'
import classnames from 'classnames'

import Header from '../Header'
import { HeaderVariant } from '../../types'
import styles from './styles.module.scss'
import Ribbon from '../Ribbon'

interface Props extends React.PropsWithChildren {
  headerVariant?: HeaderVariant
  fixedSidebar?: boolean
}

const Layout: React.FC<Props> = ({ children, fixedSidebar, headerVariant }) => {
  const innerContentClass = classnames({
    [styles.innerContentFixedSidebar]: fixedSidebar,
  })

  return (
    <>
      <Ribbon.Wrapper>
        <Ribbon.Item className={styles.ribbonDetail}>
          If you need help right away, please call us.
        </Ribbon.Item>

        <Ribbon.Item>
          <a className={styles.location} href="https://maps.app.goo.gl/3yvDuiM2mF7KK3hN9">
            Edgewater
          </a>{' '}
          <strong>
            <a className={styles.tel} href="tel:4109564488">
              (410) 956-4488
            </a>
          </strong>
        </Ribbon.Item>

        <Ribbon.Item>
          <a className={styles.location} href="https://maps.app.goo.gl/9M843QGHrnL8PLyu6">
            National Harbor
          </a>{' '}
          <strong>
            <a className={styles.tel} href="tel:3015679424">
              (301) 567-9424
            </a>
          </strong>
        </Ribbon.Item>
      </Ribbon.Wrapper>

      <Header variant={headerVariant} />

      <div className={innerContentClass}>{children}</div>
    </>
  )
}

export default Layout
